export default __webpack_public_path__ + "a8aab600d9ac24891e70c93bc7cdbd67.webp";